import { Button, TextField, CircularProgress, Select, MenuItem, InputLabel, Box, Checkbox } from '@material-ui/core'
import { Role } from '@types'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import './signupView.css'
import { clearSignup, signup, signupLoader } from './state/signupSlice'
import { executivesSelector } from '@views/tracking/state/trackingSlice2'
import { userProfile } from '@views/profile/state/profileSlice'
export const bankList = [
  //TODO: Get list from back
  'Davivienda',
  'Bancolombia',
  'Caja Social',
  'Scotiabank Colpatria',
  'AV Villas',
  'Popular',
  'Banco De Bogota',
  'Banco de Occidente',
  'FNA',
  // 'Itau',
  'Bancoomeva',
  'La Hipotecaria'
]
const SignupView: React.FC = () => {
  // const [docs, setDocs] = useState<{ name: string; value?: string }[]>([])
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [id, setId] = useState('')
  const [cel, setCel] = useState('')
  const [city, setCity] = useState('')
  const [bank, setBank] = useState('')
  const [isCrm, setIsCrm] = useState(false)
  const [income, setIncome] = useState('')
  const [comments, setComments] = useState('')
  const [executive, setExecutive] = useState({})
  const [bankDocument, setBankDocument] = useState('')
  const [mailError, setMailError] = useState(false)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const executivesList = useSelector(executivesSelector)
  const { isLoading, isSuccess, isFailed, message, createdUser } = useSelector(signupLoader)
  const { role } = useSelector(userProfile)
  const { role: paramsRole } = useParams<{ role: string }>()
  const isSaver = paramsRole !== 'miembro'
  const canManageCrm = role === Role.agente || role === Role.admin || role === Role.ejecutivo
  let onlyNumber = /^[0-9]+$/
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const selectedExecutive = role === Role.admin ? executivesList.find(item => item._id === executive) : undefined
    if (email.includes('.') && email.includes('@') && !email.includes(' ')) {
      dispatch(
        signup({
          name,
          email: email.toLowerCase(),
          files: [],
          ...(bank && { bank }),
          bankDocument,
          document: id,
          phone: cel,
          city,
          income,
          role: Role.referenciador,
          isVerified: false,
          isSaver,
          comments,
          isCrm: canManageCrm ? isCrm : false,
          ...(selectedExecutive && {
            executive: {
              id: selectedExecutive?._id,
              name: selectedExecutive?.name
            }
          })
        })
      )
    } else setMailError(true)
  }

  const handleChangeCel = (e: any) => {
    if (onlyNumber.test(e.target.value) || e.target.value === '') {
      setCel(e.target.value)
    }
  }

  const handleChangeId = (e: any) => {
    if (onlyNumber.test(e.target.value) || e.target.value === '') {
      setId(e.target.value)
    }
  }

  useEffect(() => {
    if (role === Role.agente) setIsCrm(true)
    if (!canManageCrm) setIsCrm(false)
  }, [role, canManageCrm])

  useEffect(() => {
    if (isSuccess) {
      const assignedExecutive = createdUser?.executive?.name
      enqueueSnackbar(
        assignedExecutive
          ? `Registrado correctamente! Ejecutivo asignado: ${assignedExecutive}`
          : 'Registrado correctamente!',
        { variant: 'success' }
      )
      dispatch(clearSignup())
    }
    if (isFailed) {
      const label = message.includes('409') ? 'Usuario ya registrado' : 'Error registrando usuario'
      enqueueSnackbar(label, {
        variant: 'error'
      })
    }
  }, [isSuccess, isFailed, createdUser])
  return (
    <div className="center_view">
      <h2>Registra un {isSaver ? 'nuevo ahorrador' : 'referenciador'}: </h2>
      <form className="form" onSubmit={e => handleSubmit(e)}>
        <TextField
          label="Nombre"
          required
          variant="outlined"
          margin="normal"
          onChange={e => setName(e.target.value)}
          disabled={isLoading}
        />
        <TextField
          label="Correo"
          required
          variant="outlined"
          margin="normal"
          onChange={e => setEmail(e.target.value)}
          disabled={isLoading}
          error={mailError}
        />
        {mailError ? (
          <Box color="red" margin="0">
            Email invalido
          </Box>
        ) : null}
        <TextField
          label="Cedula"
          required
          variant="outlined"
          margin="normal"
          value={id}
          onChange={handleChangeId}
          disabled={isLoading}
        />
        <TextField
          label="Celular"
          variant="outlined"
          required
          margin="normal"
          value={cel}
          onChange={handleChangeCel}
          disabled={isLoading}
        />
        <TextField
          label="Ciudad"
          variant="outlined"
          required
          margin="normal"
          onChange={e => setCity(e.target.value)}
          disabled={isLoading}
        />
        {isSaver ? (
          <>
            <InputLabel style={{ marginTop: '10px' }}>Selecciona tu banco *</InputLabel>
            <Select
              variant="outlined"
              required
              value={bank}
              onChange={e => setBank(e.target.value as string)}
              disabled={isLoading}
            >
              {bankList.map(bankName => (
                <MenuItem value={bankName} key={bankName}>
                  {bankName}
                </MenuItem>
              ))}
            </Select>
            <TextField
              label="Ingresos demostrables por los titulares del crédito"
              variant="outlined"
              margin="normal"
              onChange={e => setIncome(e.target.value)}
              disabled={isLoading}
            />
            <TextField
              label="Enlace a extracto bancario"
              variant="outlined"
              margin="normal"
              onChange={event => setBankDocument(event.target.value)}
              disabled={isLoading}
            />
            {role === Role.admin ? (
              <>
                <InputLabel id="executive-label" style={{ marginTop: '10px', marginBottom: '0.5rem' }}>
                  Ejecutivo
                </InputLabel>
                <Select
                  className="select-executive"
                  labelId="executive-label"
                  variant="outlined"
                  required
                  value={executive}
                  onChange={e => setExecutive(e.target.value as string)}
                >
                  {executivesList?.map(executive => (
                    <MenuItem value={executive._id} key={executive._id}>
                      {executive.name}
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : (
              ''
            )}
            {canManageCrm ? (
              <Box display="flex" justifyContent="left" alignItems="center">
                <Checkbox checked={isCrm} onChange={event => setIsCrm(event.target.checked)} color="secondary" />
                <InputLabel>Es promoción CRM </InputLabel>
              </Box>
            ) : null}
            <TextField
              label="Comentarios"
              variant="outlined"
              rows={2}
              multiline
              margin="normal"
              onChange={event => setComments(event.target.value)}
              disabled={isLoading}
            />
          </>
        ) : null}
        <br />
        <div className="center_row">
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button type="submit" variant="contained" color="primary" disabled={isLoading}>
              Registrar
            </Button>
          )}
        </div>
      </form>
    </div>
  )
}

export default SignupView
